import { render, staticRenderFns } from "./InsuranceOrders.vue?vue&type=template&id=0054a694&"
import script from "./InsuranceOrders.vue?vue&type=script&lang=js&"
export * from "./InsuranceOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports